/**
 * Concierge Analytics Tracking Types
 *
 * This file defines TypeScript interfaces for all concierge tracking events.
 * These types ensure type-safety when implementing tracking in the web app and mobile app.
 *
 * Event Naming Convention:
 * - Backend (ConciergeAgentEvent): Uses 'concierge:' prefix
 * - Frontend (AnalyticsTrackingEvent): Uses 'CONCIERGE_' prefix with matching event name
 *
 * Implementation Notes:
 * - Web App: Use AnalyticsService.track(AnalyticsTrackingEvent.CONCIERGE_*, properties)
 * - Mobile App: Use the equivalent tracking service with matching event names
 * - sessionId should be consistent within a browsing session (use fingerprint/visitor ID)
 */
// ============================================================================
// Helper Functions
// ============================================================================
/**
 * Get the device type based on screen width
 */
function getDeviceType() {
    if (typeof window === 'undefined')
        return 'desktop';
    const width = window.innerWidth;
    if (width < 768)
        return 'mobile';
    if (width < 1024)
        return 'tablet';
    return 'desktop';
}
/**
 * Get page name from pathname
 */
function getPageNameFromPath(pathname) {
    if (pathname === '/' || pathname === '')
        return 'Homepage';
    if (pathname.includes('/pdp/') || pathname.includes('/p/'))
        return 'Product Detail Page';
    if (pathname.includes('/brand/'))
        return 'Brand Page';
    if (pathname.includes('/search'))
        return 'Search Results';
    if (pathname.includes('/category/'))
        return 'Category Page';
    if (pathname.includes('/brandclub'))
        return 'Brandclub Page';
    return 'Other';
}
/**
 * Get page type from pathname
 */
function getPageTypeFromPath(pathname) {
    if (pathname === '/' || pathname === '')
        return 'homepage';
    if (pathname.includes('/pdp/') || pathname.includes('/p/'))
        return 'pdp';
    if (pathname.includes('/brand/'))
        return 'brand';
    if (pathname.includes('/search'))
        return 'search';
    if (pathname.includes('/category/'))
        return 'category';
    if (pathname.includes('/brandclub'))
        return 'brandclub';
    return 'other';
}
/**
 * Extract UTM parameters from URL
 */
function getUTMParams() {
    if (typeof window === 'undefined')
        return {};
    const params = new URLSearchParams(window.location.search);
    return {
        utmSource: params.get('utm_source') || undefined,
        utmMedium: params.get('utm_medium') || undefined,
        utmCampaign: params.get('utm_campaign') || undefined,
    };
}
/**
 * Truncate a string to a maximum length
 */
function truncateQuery(query, maxLength = 200) {
    if (query.length <= maxLength)
        return query;
    return query.substring(0, maxLength) + '...';
}

export { getDeviceType, getPageNameFromPath, getPageTypeFromPath, getUTMParams, truncateQuery };
//# sourceMappingURL=ConciergeTrackingTypes.js.map
